export const getArgs = (args) => ({
    coords: args[0],
    speed: args[1],
    width: args[2],
    stepNumber: args[3],
    history: args[4],
    effect: args[6]
});
